<template>
    <router-view />
</template>

<style lang="less">
@import url('./style/index.less');
html,
body,
#app {
    width: 100vw;
    height: 100vh;
    margin: 0 auto;
    background-color: #f5f7f9;
    // font-family: 'Avenir', Helvetica, Arial, sans-serif, 'Microsoft YaHei', 'PingFang SC';
    font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', 'miui', 'Hiragino Sans GB', 'Microsoft Yahei', sans-serif;
    -webkit-font-smoothing: antialiased;
    -webkit-overflow-scrolling: touch;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    font-size: 16px;
    overflow: hidden;
}
</style>
